var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6656 0L6.33437 9.66562L2 5.33437L0 7.33438L6.66563 14L16 2L13.6656 0Z",
    fill: "#73DC9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickNew);
export default __webpack_public_path__ + "static/media/tick-new.74d725ab23953154b0edd580341db598.svg";
export { ForwardRef as ReactComponent };